import React from 'react';
import Checkbox from '../inputs/Checkbox';

type TokyoCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

const TokyoCheckbox: React.FC<TokyoCheckboxProps> = ({
  checked,
  onChange,
  className,
}) => {
  return (
    <Checkbox
      label="東京"
      checked={checked}
      onChange={onChange}
      className={className}
    />
  );
};

export default TokyoCheckbox;
